/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_DELETEVIDEOCLIP,DELETEVIDEOCLIP_RECEIVED, CLEAR_DELETEVIDEOCLIP } = constants.DeleteVideoClipConstant;

export default {
    REQUEST_DELETEVIDEOCLIP,
    DELETEVIDEOCLIP_RECEIVED,
    CLEAR_DELETEVIDEOCLIP,

  requestDeleteVideoClip: payload => ({
    type: REQUEST_DELETEVIDEOCLIP,
    payload
  }),
  DeleteVideoClipReceived: () => ({
    type: DELETEVIDEOCLIP_RECEIVED
  }),
};
